import isMobile from 'ismobilejs';
import WebComponent from 'fg-frontend/src/webComponents/WebComponent';

const fragments = {
	BUTTON_CLOSE: '[data-fragment="AppealTurnPhone.buttonClose"]',
};

class AppealTurnPhone extends WebComponent {
	constructor(props) {
		super(props);
		const {
		} = props;
		this.state = {
		};
	}

	didMount() {
		const {
			activeClass,
			cookieName,
		} = this.props;

		this.activeClass = activeClass;
		this.cookieName = cookieName;

		this.checkCookie();
		this.on('click', fragments.BUTTON_CLOSE, this.handleClickOnButtonClose);
		window.addEventListener("orientationchange", () => {
			this.initElement();
		}, false);
		/**
		 * init mobile detection
		 */
		this.isMobile = isMobile;
		this.initElement();
	}

	initElement = () => {
		if(this.isMobile.phone && screen.orientation.type === "portrait-primary" && (this.getCookie(this.cookieName) === "1" || this.getCookie(this.cookieName) === "")) {
			this.element.classList.add(this.activeClass);
		} else {
			this.closeElement();
		}
	}

	closeElement = () => {
		this.element.classList.remove(this.activeClass);
		this.setCookie(this.cookieName, 0, 7);
	}

	handleClickOnButtonClose = (e) => {
		e.preventDefault();
		this.closeElement();
	};

	setCookie(cName, cValue, cDate) {
		let d = new Date();
		d.setTime(d.getTime() + (cDate*24*60*60*1000));
		let expires = "expires="+ d.toUTCString();
		document.cookie = cName + "=" + cValue + ";" + expires + ";path=/";
	}

	getCookie(cName) {
		var name = cName + "=";
		var ca = document.cookie.split(';');
		for(var i = 0; i < ca.length; i++) {
			var c = ca[i];
			while (c.charAt(0) == ' ') {
				c = c.substring(1);
			}
			if (c.indexOf(name) == 0) {
				return c.substring(name.length, c.length);
			}
		}
		return "";
	}

	checkCookie() {
		let name = this.getCookie(this.cookieName);
		if (name === "" && name == null) {
			this.setCookie(this.cookieName, 1, 7);
		}
	}

	willUnMount() {
		this.elements = null;
	}
}

AppealTurnPhone.defaultProps = {
	activeClass: 'appeal-turn-phone--open',
	cookieName: 'appealTurnPhone',
}

export default AppealTurnPhone;




// WEBPACK FOOTER //
// ./config/module-publish/resources/js/components/AppealTurnPhone.js